@use 'src/global/variables.scss' as var;
@use 'src/global/mixins/feedback.scss' as fb;

c-dropdown {
  display: block;
  min-width: calc(100% - 24px);
  max-width: calc(100% - 24px);
  &.bubble-container-with-feedback {
    @include fb.bubble-container-with-feedback;
  }

  section {
    background-color: var.$primary-color;
    padding: 1rem;
    box-shadow: var.$message-screen-elements-box-shadow;
    box-sizing: border-box;
    border-radius: 20px;
    color: var.$text-color-light;

    .introductory-text {
      margin: 0;
    }

    select {
      margin-top: 10px;
      margin-bottom: 12px;
      width: 100%;
      outline: none;
      box-shadow: none;

      height: 2.8rem;
      padding: 0.5rem 1rem;
      border: 1px solid #000;
      border-radius: 5px;
      font-size: 16px; // To prevent auto zoom in on iPhones, we need font-size >= 16px
      line-height: 1.8rem;
      color: black;

      background: #fff no-repeat right 1rem center;
      background-image: url(data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiB2aWV3Qm94PSIwIDAgMTAwIDEwMCI+PHBhdGggZD0iTTUxIDUuNTZjMjUuMDQ3IDAgNDUuNDQgMjAuMzkzIDQ1LjQ0IDQ1LjQ0Uzc2LjA0OCA5Ni40NCA1MSA5Ni40NCA1LjU2IDc2LjA0OCA1LjU2IDUxIDI1Ljk1MiA1LjU2IDUxIDUuNTZtMC0yLjk3QzI0LjI3IDIuNTkgMi41OSAyNC4yNyAyLjU5IDUxYzAgMjYuNzMgMjEuNjggNDguNDEyIDQ4LjQxIDQ4LjQxMiAyNi43MyAwIDQ4LjQxMi0yMS42ODIgNDguNDEyLTQ4LjQxMlM3Ny43MyAyLjU5IDUxIDIuNTl6Ii8+PHBhdGggZD0iTTM0LjU2NiA0MC4xMWMtLjE5OCAwLS4yOTcuMS0uNDk1LjE5OGwtMy4wNjggMy4wN2MtLjI5Ny4yOTYtLjI5Ny42OTIgMCAuOTlMNTAuMjEgNjMuNTczYy4xOTcuMTk4LjQ5NC4yOTcuNzkuMTk4LjI5OC4xLjQ5Ni4xLjc5My0uMTk4TDcxIDQ0LjM2N2MuMjk2LS4yOTYuMjk2LS42OTIgMC0uOTlsLTMuMTctMi45N2MtLjI5Ni0uMjk2LS42OTItLjI5Ni0uOTkgMEw1MSA1Ni4yNDdsLTE1Ljk0LTE1Ljg0Yy0uMDk4LS4xOTgtLjI5Ni0uMjk3LS40OTQtLjI5N3oiLz48L3N2Zz4=);
      background-size: 1.4rem 1.4rem;

      appearance: none;
      -webkit-appearance: none;

      &:focus {
        outline: 3px solid var.$focus-color;
        border-color: var.$focus-color;
      }

      &.disabled {
        opacity: 1;
        background: var.$primary-color no-repeat right 1rem center;
        background-image: url(data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiB2aWV3Qm94PSIwIDAgMTAwIDEwMCI+DQo8cGF0aCBmaWxsPSIjZmZmIiBzdHJva2U9IiNmZmYiIHN0cm9rZS13aWR0aD0iMyUiIGQ9Ik01MSA1LjU2YzI1LjA0NyAwIDQ1LjQ0IDIwLjM5MyA0NS40NCA0NS40NFM3Ni4wNDggOTYuNDQgNTEgOTYuNDQgNS41NiA3Ni4wNDggNS41NiA1MSAyNS45NTIgNS41NiA1MSA1LjU2bTAtMi45N0MyNC4yNyAyLjU5IDIuNTkgMjQuMjcgMi41OSA1MWMwIDI2LjczIDIxLjY4IDQ4LjQxMiA0OC40MSA0OC40MTIgMjYuNzMgMCA0OC40MTItMjEuNjgyIDQ4LjQxMi00OC40MTJTNzcuNzMgMi41OSA1MSAyLjU5eiIvPg0KPHBhdGggZmlsbD0iI2ZmZiIgZD0iTTM0LjU2NiA0MC4xMWMtLjE5OCAwLS4yOTcuMS0uNDk1LjE5OGwtMy4wNjggMy4wN2MtLjI5Ny4yOTYtLjI5Ny42OTIgMCAuOTlMNTAuMjEgNjMuNTczYy4xOTcuMTk4LjQ5NC4yOTcuNzkuMTk4LjI5OC4xLjQ5Ni4xLjc5My0uMTk4TDcxIDQ0LjM2N2MuMjk2LS4yOTYuMjk2LS42OTIgMC0uOTlsLTMuMTctMi45N2MtLjI5Ni0uMjk2LS42OTItLjI5Ni0uOTkgMEw1MSA1Ni4yNDdsLTE1Ljk0LTE1Ljg0Yy0uMDk4LS4xOTgtLjI5Ni0uMjk3LS40OTQtLjI5N3oiLz4NCjwvc3ZnPg==);
        background-size: 1.4rem 1.4rem;
        border: 1px solid var.$text-color-light;
        color: var.$text-color-light;
        cursor: not-allowed;
      }
    }

    option {
      font-style: normal;
      padding: 30px;
    }
  }
}
